<template>
  <div
    class="h-full w-full overflow-y-auto overflow-x-hidden px-2 py-12 sm:px-6 lg:px-8"
  >
    <div class="flex min-h-full flex-col justify-center">
      <div class="sm:mx-auto sm:w-full sm:max-w-md">
        <div class="flex items-center justify-center px-8">
          <IconBrandLogo class="w-full" />
        </div>

        <h2
          class="text-background-fg/90 mt-6 text-center text-3xl font-extrabold"
        >
          Access to your group web portal
        </h2>
      </div>

      <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <BaseCard class="relative">
          <BaseTabs
            v-model="logInType"
            :tabs="logInTypeOptions"
          />
          <MerchantGroupRequestAccessLinkForm
            v-if="logInType === 'email-link'"
          />
          <MerchantGroupPasswordLoginForm
            v-else-if="logInType === 'password'"
          />
        </BaseCard>
        <RouterLink
          class="flex w-full"
          :to="{ name: 'login' }"
          ><span
            class="text-primary mt-4 w-full text-center"
            >Login to single merchant portal</span
          ></RouterLink
        >
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { TabOption } from "@/components/BaseTabs.vue"
import { RouterLink } from "vue-router"

type LogInType = "email-link" | "password"

const logInType = ref<LogInType>("email-link")

const logInTypeOptions: Array<TabOption> = [
  {
    value: "email-link",
    label: "Email Link",
  },
  {
    value: "password",
    label: "Password",
  },
]
</script>
